/**
 * Centralized logging utility for the application
 * Allows disabling logs in production or via environment variable
 */

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LOG_ENABLED = process.env.NODE_ENV === 'development';
const LOG_PREFIX = '[SentiHype]';

class Logger {
  private shouldLog(level: LogLevel): boolean {
    if (!LOG_ENABLED) return false;
    
    // Можно добавить фильтрацию по уровню логирования
    const logLevelStr = (process.env.REACT_APP_LOG_LEVEL || 'debug').toLowerCase();
    const levels: LogLevel[] = ['debug', 'info', 'warn', 'error'];
    const logLevel: LogLevel = levels.includes(logLevelStr as LogLevel) ? (logLevelStr as LogLevel) : 'debug';
    const currentLevelIndex = levels.indexOf(logLevel);
    const messageLevelIndex = levels.indexOf(level);
    
    return messageLevelIndex >= currentLevelIndex;
  }

  debug(message: string, ...args: any[]): void {
    if (this.shouldLog('debug')) {
      console.log(`${LOG_PREFIX} [DEBUG] ${message}`, ...args);
    }
  }

  info(message: string, ...args: any[]): void {
    if (this.shouldLog('info')) {
      console.log(`${LOG_PREFIX} [INFO] ${message}`, ...args);
    }
  }

  warn(message: string, ...args: any[]): void {
    if (this.shouldLog('warn')) {
      console.warn(`${LOG_PREFIX} [WARN] ${message}`, ...args);
    }
  }

  error(message: string, ...args: any[]): void {
    if (this.shouldLog('error')) {
      console.error(`${LOG_PREFIX} [ERROR] ${message}`, ...args);
    }
  }
}

// Создаем именованные логгеры для разных модулей
export const createLogger = (module: string) => {
  const modulePrefix = `${LOG_PREFIX} [${module}]`;
  
  return {
    debug: (message: string, ...args: any[]) => {
      if (LOG_ENABLED) {
        console.log(`${modulePrefix} [DEBUG] ${message}`, ...args);
      }
    },
    info: (message: string, ...args: any[]) => {
      if (LOG_ENABLED) {
        console.log(`${modulePrefix} [INFO] ${message}`, ...args);
      }
    },
    warn: (message: string, ...args: any[]) => {
      if (LOG_ENABLED) {
        console.warn(`${modulePrefix} [WARN] ${message}`, ...args);
      }
    },
    error: (message: string, ...args: any[]) => {
      if (LOG_ENABLED) {
        console.error(`${modulePrefix} [ERROR] ${message}`, ...args);
      }
    },
  };
};

export const logger = new Logger();
